/**
 * <purchase-toast>
 * Cycles fake recent-purchase notifications on the product page.
 * Product name is hardcoded; name, city, qty, and time vary.
 */
class PurchaseToast extends HTMLElement {
  static NAMES = [
    'Sarah', 'James', 'Emily', 'Michael', 'Ashley', 'David', 'Jessica', 'Chris',
    'Amanda', 'Ryan', 'Lauren', 'Matt', 'Nicole', 'Brian', 'Megan', 'Kevin',
    'Rachel', 'Jason', 'Stephanie', 'Andrew', 'Kayla', 'Tyler', 'Brittany', 'Josh',
    'Hannah', 'Daniel', 'Olivia', 'Alex', 'Madison', 'Nate',
  ];

  static INITIALS = 'ABCDEFGHJKLMNPRSTW';

  static CITIES = [
    'Austin, TX', 'Denver, CO', 'Seattle, WA', 'Portland, OR', 'Chicago, IL',
    'Nashville, TN', 'Atlanta, GA', 'Boston, MA', 'Phoenix, AZ', 'San Diego, CA',
    'Miami, FL', 'Dallas, TX', 'Minneapolis, MN', 'Charlotte, NC', 'Columbus, OH',
    'Salt Lake City, UT', 'Boise, ID', 'Tampa, FL', 'Raleigh, NC', 'Kansas City, MO',
    'Pittsburgh, PA', 'San Antonio, TX', 'Orlando, FL', 'Sacramento, CA', 'Detroit, MI',
    'Indianapolis, IN', 'Brooklyn, NY', 'Boulder, CO', 'Scottsdale, AZ', 'Bend, OR',
  ];

  static QUANTITIES = [1, 1, 1, 2, 2, 3];

  static TIMES = [
    'just now',
    '1 minute ago',
    '2 minutes ago',
    '3 minutes ago',
    '5 minutes ago',
    '8 minutes ago',
    '12 minutes ago',
    '18 minutes ago',
  ];

  #timer = null;
  #hideTimer = null;
  #shown = 0;
  #maxShows = 0;

  connectedCallback() {
    this.nameEl = this.querySelector('[data-toast-name]');
    this.cityEl = this.querySelector('[data-toast-city]');
    this.qtyEl = this.querySelector('[data-toast-qty]');
    this.timeEl = this.querySelector('[data-toast-time]');
    this.closeBtn = this.querySelector('[data-toast-close]');

    this.#maxShows = Number(this.dataset.maxShows) || 8;
    const delay = Number(this.dataset.initialDelay) || 4000;

    this.closeBtn?.addEventListener('click', this.#dismiss);
    this.#timer = setTimeout(() => this.#cycle(), delay);
  }

  disconnectedCallback() {
    clearTimeout(this.#timer);
    clearTimeout(this.#hideTimer);
    this.closeBtn?.removeEventListener('click', this.#dismiss);
  }

  #pick(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  #buildPurchase() {
    const first = this.#pick(PurchaseToast.NAMES);
    const last = this.#pick(PurchaseToast.INITIALS);
    const qty = this.#pick(PurchaseToast.QUANTITIES);

    return {
      name: `${first} ${last}.`,
      city: this.#pick(PurchaseToast.CITIES),
      qty,
      qtyLabel: qty === 1 ? '1' : String(qty),
      time: this.#pick(PurchaseToast.TIMES),
    };
  }

  #render(purchase) {
    if (this.nameEl) this.nameEl.textContent = purchase.name;
    if (this.cityEl) this.cityEl.textContent = purchase.city;
    if (this.qtyEl) this.qtyEl.textContent = purchase.qtyLabel;
    if (this.timeEl) this.timeEl.textContent = purchase.time;
  }

  #show() {
    this.setAttribute('data-visible', 'true');
    this.setAttribute('aria-hidden', 'false');
  }

  #hide() {
    this.removeAttribute('data-visible');
    this.setAttribute('aria-hidden', 'true');
  }

  #cycle = () => {
    if (this.#shown >= this.#maxShows) return;

    this.#render(this.#buildPurchase());
    this.#show();
    this.#shown += 1;

    const visibleFor = Number(this.dataset.visibleFor) || 5500;
    const gap = Number(this.dataset.gap) || 9000;

    this.#hideTimer = setTimeout(() => {
      this.#hide();
      if (this.#shown < this.#maxShows) {
        this.#timer = setTimeout(() => this.#cycle(), gap);
      }
    }, visibleFor);
  };

  #dismiss = () => {
    clearTimeout(this.#timer);
    clearTimeout(this.#hideTimer);
    this.#hide();
    this.#shown = this.#maxShows;
  };
}

if (!customElements.get('purchase-toast')) {
  customElements.define('purchase-toast', PurchaseToast);
}
